module.exports = __webpack_public_path__ + "static/media/corteC.85cb57bb.png";